import { DateTime } from "luxon";

const LOCALE = "fr-FR";

class DateFormat {
  standardDate(date: Date): string {
    const browserTimezone = DateTime.local().zone;
    return DateTime.fromJSDate(date)
      .setZone(browserTimezone)
      .setLocale(LOCALE)
      .toFormat("dd/MM/yyyy à HH'h'mm");
  }

  certificateDate(date: Date): string {
    const browserTimezone = DateTime.local().zone;
    return DateTime.fromJSDate(date)
      .setZone(browserTimezone)
      .setLocale(LOCALE)
      .toFormat("dd/MM/yyyy");
  }

  certificateDateWithMonth(date: Date): string {
    const browserTimezone = DateTime.local().zone;
    return DateTime.fromJSDate(date)
      .plus({ month: 1 })
      .setZone(browserTimezone)
      .toFormat("dd/MM/yyyy");
  }

  dashboardDate(date: Date): string {
    const browserTimezone = DateTime.local().zone;
    return DateTime.fromJSDate(date)
      .setZone(browserTimezone)
      .setLocale(LOCALE)
      .toFormat("dd MMM yyyy");
  }

  dashboardDateWithDays(date: Date, days?: number): string {
    const browserTimezone = DateTime.local().zone;
    return DateTime.fromJSDate(date)
      .plus({ days: days ? days : 0 })
      .setZone(browserTimezone)
      .setLocale(LOCALE)
      .toFormat("dd MMM HH:mm");
  }

  fullDate(date: Date): string {
    const browserTimezone = DateTime.local().zone;
    return DateTime.fromJSDate(date)
      .setZone(browserTimezone)
      .setLocale(LOCALE)
      .toFormat("dd MMMM yyyy, HH:mm");
  }

  dashboardPeriodDate(date: string): string {
    const browserTimezone = DateTime.local().zone;
    return DateTime.fromISO(date)
      .setZone(browserTimezone)
      .setLocale(LOCALE)
      .toFormat("d MMMM");
  }

  calendarDashboardPeriodDate(date: Date): string {
    const browserTimezone = DateTime.local().zone;
    return DateTime.fromJSDate(date)
      .setZone(browserTimezone)
      .setLocale(LOCALE)
      .toFormat("yyyy-MM-dd");
  }

  initialDashboardStartPeriodDate(): string {
    const browserTimezone = DateTime.local().zone;
    return DateTime.now()
      .minus({ month: 1 })
      .setZone(browserTimezone)
      .setLocale(LOCALE)
      .toFormat("yyyy-MM-dd");
  }

  initialDashboardEndPeriodDate(): string {
    const browserTimezone = DateTime.local().zone;
    return DateTime.now()
      .setZone(browserTimezone)
      .setLocale(LOCALE)
      .toFormat("yyyy-MM-dd");
  }
}

export default new DateFormat();
